/* unplugin-vue-components disabled */import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5bdd26c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdd26c1"]])

export default __exports__